import { render, staticRenderFns } from "./scriptDistribution.vue?vue&type=template&id=74996924&"
import script from "./scriptDistribution.vue?vue&type=script&lang=js&"
export * from "./scriptDistribution.vue?vue&type=script&lang=js&"
import style0 from "./scriptDistribution.vue?vue&type=style&index=0&id=74996924&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports